<template>
  <b-col lg="12" class="kendo_table_wrapper custom_index">
    <fullscreen
      class="full-screen"
      :class="{ 'col-12': isFullScreen }"
      ref="fullscreen"
      :fullscreen.sync="isFullScreen"
    >
      <div class="row" :class="{ 'm-0': isFullScreen }">
        <div class="col-12">
          <div class="row">
            <h3 class="d-block heading-text mb-2">Custom Index</h3>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-12 pr-0 pl-0">
              <div class="row dropdown-button-container">
                <div class="col-10 col-lg-11">
                  <b-row class="">
                    <b-col class="col-12 col-lg-12">
                      <k-form>
                        <div class="row">
                          <p class="d-none">{{ temp }}</p>
                          <!-- dynamic kendo dropdown generated by API responce -->
                          <b-form-group
                            class="col-4 mr-3 max-width-dropdown"
                            :label="dropDownData.Name"
                            v-for="dropDownData of custom_index_dropdown"
                            :key="dropDownData.Name"
                          >
                            <b-row>
                              <dropdownlist
                                :class="{
                                  'border border-danger':
                                    !customIndexError[dropDownData.Key].valid &&
                                    customIndexError[dropDownData.Key].message
                                      .length > 0,
                                }"
                                class="w-100"
                                :v-model="dropDownData.Key"
                                :name="dropDownData.Key"
                                :data-items="dropDownData.data"
                                :text-field="'Name'"
                                :data-item-key="'Id'"
                                @change="onChange($event)"
                                v-model="defaultItem[dropDownData.Key]"
                              >
                              </dropdownlist>
                              <p
                                v-if="
                                  !customIndexError[dropDownData.Key].valid &&
                                    customIndexError[dropDownData.Key].message
                                      .length > 0
                                "
                                class="position-absolute small text-danger small-text-error"
                              >
                                {{ customIndexError[dropDownData.Key].message }}
                              </p>
                            </b-row>
                          </b-form-group>
                          <b-form-group
                            class="col-2 pr-0 mr-2"
                            style="max-width: 117px !important;"
                            :label="'Risk-free rate(%)'"
                          >
                            <b-form-input
                              class="col-12 RiskAdjustedReturn p-0 pl-2"
                              v-model="RiskAdjustedReturn"
                              type="number"
                              placeholder="3%"
                              @input="RiskAdjustedReturnHandler"
                            ></b-form-input>
                            <div class="infoDiv infoDivIcon" id="benchMarkId">
                              <i class="fas fa-info-circle"></i>
                            </div>
                            <b-tooltip target="benchMarkId" triggers="hover">
                              Used to calculate ratios in Risk adjusted return
                            </b-tooltip>
                            <p
                              v-if="
                                !customIndexError.RiskAdjustedReturn.valid &&
                                  customIndexError.RiskAdjustedReturn.message
                                    .length > 0
                              "
                              class="position-absolute small text-danger small-text-error"
                            >
                              {{ customIndexError.RiskAdjustedReturn.message }}
                            </p>
                          </b-form-group>
                          <b-form-group class="col p-0 pr-0 mr-2">
                            <b-button
                              :type="'submit'"
                              class="btn filterBtn"
                              style="margin: 0;"
                              @click="handleSubmit"
                              :disabled="
                                handleSubmitToggel ||
                                  this.pulseLoader.pricePerformance.table ||
                                  this.pulseLoader.RiskAdjusted.table
                              "
                            >
                              Apply
                            </b-button>
                          </b-form-group>
                        </div>
                      </k-form>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-2 col-lg-1 p-0" style="text-align: right;">
                  <b-form-group class="col-md-12 p-0">
                    <b-button
                      class="btn downloadBtn"
                      title="Export to Excel"
                      :theme-color="'primary'"
                      :disabled="items && !items.length"
                      @click="exportExcel"
                    >
                      <img :src="DownloadIcon" alt="'DownloadIcon" />
                    </b-button>
                    <button
                      type="button"
                      title="Full Screen"
                      class="btn downloadBtn mr-0 d-none"
                      style="display: none !important;"
                      @click="toggle"
                    >
                      <img :src="FullScreen" alt="'FullScreen" />
                    </button>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-2">
          <div class="row pt-4">
            <div class="col-md-6 pl-0 pr-3">
              <h5
                class="position-absolute pt-3"
                style="color: #404953; top: -40px;"
              >
                {{ chartTitle }}
              </h5>
              <div class="table-card">
                <div class="row">
                  <PulseLoader
                    v-if="PulseLoaderToggle.table"
                    :style="{ maxHeight: '500px' }"
                    :title="LoaderTitle"
                  ></PulseLoader>
                </div>
                <Grid
                  :style="{ maxHeight: '500px' }"
                  :class="{
                    no_records: items && !items.length,
                  }"
                  :data-items="items"
                  :skip="skip"
                  :take="take"
                  :total="total"
                  :pageable="pageable"
                  :page-size="pageSize"
                  :sort="sort"
                  :columns="columns"
                  :columnMenu="false"
                  @pagechange="pageChangeHandler"
                  @datastatechange="dataStateChange"
                  :cell-render="'myCellTemplate'"
                >
                  <!-- add custom button in every table column -->
                  <!-- <template v-slot:myTemplate="{ props }">
                  <div class="customTableHeadeButton">
                    {{ props.field }}
                    <div style="display: inline; float: right;">
                      <span
                        class="k-link"
                        @click="sortChangeHandler(props, $event)"
                      >
                        <span class="k-icon k-i-sort-desc-sm"></span>
                        <span class="k-icon k-i-sort-asc-sm"></span>
                      </span>
                    </div>
                    <div
                      :id="props.field"
                      @click="customHandler(props, $event)"
                      style="display: inline;"
                    >
                      <div
                        tabindex="0"
                        title="Filter"
                        class="k-grid-column-menu k-grid-filter"
                      >
                        <span class="k-icon k-i-more-vertical"></span>
                      </div>
                    </div>
                  </div>
                </template> -->
                  <template v-slot:myCellTemplate="{ props }">
                    <td
                      :class="
                        props.dataItem[props.field].toString().length < 5
                          ? 'text-right'
                          : 'text-left'
                      "
                    >
                      {{ numberFormater(props.field, props.dataItem) }}
                    </td>
                  </template>
                </Grid>
              </div>
              <p
                v-if="!PulseLoaderToggle.table"
                class="font_size_12 font-weight-bold pt-2 m-0"
              >
                Custom index with a history of 5 years is calculated using a
                backtesting approach and is displayed in above table.
              </p>
            </div>
            <div class="col-md-6 pl-3 pr-0">
              <!-- <lineChart class="col-12" style="max-width: 200px; max-heght: 200px;"></lineChart> -->
              <div class="lineChartWrapper">
                <div class="row">
                  <PulseLoader
                    v-if="PulseLoaderToggle.chart"
                    :style="{ maxHeight: '500px' }"
                    :title="LoaderTitle"
                  ></PulseLoader>
                </div>
                <lineChart
                  class="svgChart"
                  :name="'Custom index chart'"
                  :chartData="items"
                ></lineChart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fullscreen>
  </b-col>
</template>

<script>
import {
  Grid,
  GridToolbar,
  filterGroupByField,
  sortGroupByField,
} from "@progress/kendo-vue-grid";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { provideLocalizationService } from "@progress/kendo-vue-intl";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import Products from "./data.json";
import LineChart from "../../charts/PlotlyCharts/LineChart.vue";
import { Form } from "@progress/kendo-vue-form";
import DownloadIcon from "../../../assets/img/Download_icon.svg";
import FullScreen from "../../../assets/img/icons/svg/full_screen.svg";
import PulseLoader from "./PulseLoader.vue";

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast);

export default {
  name: "Customindex",
  components: {
    Grid: Grid,
    // toolbar: GridToolbar,
    dropdownlist: DropDownList,
    lineChart: LineChart,
    "k-form": Form,
    PulseLoader,
  },
  // get data form props and then set in table
  props: {
    customIndexDropDown: {
      type: Array,
      default() {
        return [];
      },
    },
    finalSectorKendoTableData: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
    customIndexTableData: {
      type: Object,
      default() {
        return {};
      },
    },
    selectedBenchMarkNameTitle: {
      type: String,
      default() {
        return {};
      },
    },
    pulseLoader: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    customIndexDropDown: {
      deep: true,
      handler() {
        this.custom_index_dropdown = this.customIndexDropDown.length
          ? this.customIndexDropDown
          : [];
      },
    },
    selectedBenchMarkNameTitle: {
      deep: true,
      handler() {
        this.chartTitle = this.selectedBenchMarkNameTitle.length
          ? this.selectedBenchMarkNameTitle
          : "";
      },
    },
    customIndexTableData: {
      deep: true,
      handler() {
        this.dataItems = [];
        this.dataItems =
          this.customIndexTableData &&
          this.customIndexTableData.table_data &&
          this.customIndexTableData.table_data.length
            ? this.customIndexTableData.table_data
            : [];
        this.take = this.dataItems.length;
        this.pageSize = this.dataItems.length;
        this.columns = [];
        this.columns =
          this.customIndexTableData &&
          this.customIndexTableData.table_column &&
          this.customIndexTableData.table_column.length
            ? this.customIndexTableData.table_column
            : [];
        this.columns.forEach((col) => {
          delete col.columnMenu;
          col.locked = false;
          col.className = col.filter === "numeric" ? "text-right" : "";
        });
      },
    },
    pulseLoader: {
      deep: true,
      handler() {},
    },
  },
  data: function() {
    return {
      SelectedValue: {},
      DownloadIcon,
      FullScreen,
      defaultItem: {},
      index_methodology_type: "",
      rebelencing_frequency: "",
      index_frequency: "",
      benchmark_index: "",
      custom_index_dropdown:
        this.customIndexDropDown && this.customIndexDropDown.length
          ? this.customIndexDropDown
          : [],
      applyFilterData: [],
      isFullScreen: false,
      dropDownToggle: true,
      skip: 0,
      sort: [],
      take: 5,
      pageSize: 10,
      group: [],
      pageable: {
        buttonCount: 5,
        info: true,
        type: "numeric",
        pageSizes: true,
        previousNext: true,
      },
      dataItems: [],
      itemData: [],
      columns: [],
      chartData: [],
      chartData1: [],
      temp: {},
      handleSubmitToggel: false,
      selectedDropDownName: [],
      RiskAdjustedReturn: 3,
      customIndexError: {
        IndexMethodologyType: {
          valid: false,
          message: "",
        },
        RebalancingFrq: {
          valid: false,
          message: "",
        },
        IndexFrq: {
          valid: false,
          message: "",
        },
        BenmarkIndex: {
          valid: false,
          message: "",
        },
        RiskAdjustedReturn: {
          valid: true,
          message: "",
        },
      },
      chartTitle: "",
      selectedBenchMarkName: "",
      LoaderTitle: "Please wait Loading...",
      PulseLoaderToggle: this.pulseLoader.customeIndex,
    };
  },
  computed: {
    defaultSelectedItems: {
      get: function() {
        return this.defaultItem;
      },
    },
    items: {
      get: function() {
        // console.log("dummyDataaaaaaa", DummyData[0].pricePerformance[0]);
        // if (this.dataItems.length) {
        return this.dataItems.slice(this.skip, this.take + this.skip);
        // } else {
        // return this.itemData.slice(this.skip, this.take + this.skip);
        // }
      },
    },
    total() {
      return this.dataItems ? this.dataItems.length : 0;
    },
    // export to excel
    exportExcelMessage() {
      return provideLocalizationService(this).toLanguageString(
        "exportExcel",
        "Export to Excel"
      );
    },
  },
  mounted() {
    this.changeHandler("previousNext", true);
    // this.dataItems = this.itemData;
    // document.addEventListener("click", this.closeForm);
    // custom index chart data API method
    // this.getChartData();
    // push data, which filter is applied on UI, onload default select filter
    if (this.custom_index_dropdown.length) {
      for (let src of this.custom_index_dropdown) {
        let obj = {
          Name: src.Key,
          Id: src.data[0].Id,
        };
        this.applyFilterData.push(obj);
        // every dropdown array first object is default selected
        this.defaultItem[src.Key] = {
          Id: src.data[0].Id,
          Name: src.data[0].Name,
        };
        this.customIndexError[src.Key] = {
          valid: true,
          message: "",
        };
        if (src.Key === "BenmarkIndex") {
          this.selectedBenchMarkName = src.data[0].Name;
        }
      }
    }
    // this.handleSubmit();
  },
  methods: {
    // when dropdown change then set selected value id on applyFilterData respactive object
    onChange(event) {
      // console.log("event=======>>", event);
      let indexNumber;
      let target = event.target;
      let value = event.target.value;
      if (value.Id) {
        this.customIndexError[target.name] = {
          valid: true,
          message: "",
        };
        if (target.name === "BenmarkIndex") {
          this.selectedBenchMarkName = "";
          this.selectedBenchMarkName = target.value.Name;
        }
      } else {
        this.customIndexError[target.name] = {
          valid: false,
          message: "Please select valid value",
        };
      }
      // find index number of selected dropdown
      this.applyFilterData.forEach((data, index) => {
        if (data.Name === target.name) {
          indexNumber = index;
          return;
        }
      });
      let applyFilter = this.applyFilterData[indexNumber];
      if (applyFilter.Name) {
        applyFilter.Id = value.Id;
        // default selected value also update because v-modal need update value
        this.defaultItem[applyFilter.Name].Id = value.Id;
        this.defaultItem[applyFilter.Name].Name = value.Name;
        this.temp = {
          Id: value.Id,
          Name: value.Name,
        };
      }
      this.ApplyButtonDisabledToggel();
      // this.handleSubmit();
    },
    RiskAdjustedReturnHandler() {
      if (this.RiskAdjustedReturn !== "") {
        this.customIndexError.RiskAdjustedReturn = {
          valid: true,
          message: "",
        };
      } else {
        this.customIndexError.RiskAdjustedReturn = {
          valid: false,
          message: "Please enter valid number",
        };
      }
      this.ApplyButtonDisabledToggel();
    },
    ApplyButtonDisabledToggel() {
      if (
        this.customIndexError.IndexMethodologyType.valid &&
        this.customIndexError.IndexMethodologyType.message.length < 1 &&
        this.customIndexError.RebalancingFrq.valid &&
        this.customIndexError.RebalancingFrq.message.length < 1 &&
        this.customIndexError.IndexFrq.valid &&
        this.customIndexError.IndexFrq.message.length < 1 &&
        this.customIndexError.BenmarkIndex.valid &&
        this.customIndexError.BenmarkIndex.message.length < 1 &&
        this.customIndexError.RiskAdjustedReturn.valid &&
        this.customIndexError.RiskAdjustedReturn.message.length < 1
      ) {
        this.handleSubmitToggel = false;
      } else {
        this.handleSubmitToggel = true;
      }
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    // ---------------------
    updatePagerState: function(key, value) {
      const newPageableState = Object.assign({}, this.pageable, {
        [key]: value,
      });
      this.pageable = newPageableState;
    },
    changeHandler: function(type, value) {
      this.updatePagerState(type, value);
    },
    // pageinatipon---
    getData: function() {
      let dataForSorting = this.dataItems;
      let dataState = {
        take: this.take,
        skip: this.skip,
        group: this.group,
        filter: this.filter,
        sort: this.sort,
      };
      let afterSortData = process(dataForSorting, dataState);
      this.dataItems = [];
      if (afterSortData.data.length) {
        for (let d of afterSortData.data) {
          this.dataItems.push(d);
        }
      }
    },
    // filter data by default functionaly
    createAppState: function(dataState) {
      this.group = dataState.group;
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.sort = dataState.sort;
      this.filter = dataState.filter;
      this.getData();
    },
    dataStateChange: function(event) {
      this.createAppState(event.data);
    },
    // export to excel
    // export table data here in excel--------
    exportExcel() {
      const columnsToExport = [...this.columns];
      columnsToExport.splice(0, 0);
      saveExcel({
        data: this.items,
        group: this.group,
        fileName: "Custom Index Report",
        columns: columnsToExport,
      });
    },
    // full screen table
    toggle() {
      this.isFullScreen = !this.isFullScreen;
    },
    // on click apply button or change dropdown value emit from here to parent.
    handleSubmit() {
      if (this.finalSectorKendoTableData.length > 0) {
        let CorpId = [];
        // sector table all row corpId push in array.
        for (let tableRow of this.finalSectorKendoTableData) {
          CorpId.push(tableRow.CorpId);
        }
        CorpId.sort(function(a, b) {
          return a - b;
        });
        // create object with selected dropdown value, in the form of key value pair.
        let applyFilterObj = {};
        for (let afilterData of this.applyFilterData) {
          applyFilterObj[afilterData.Name.replaceAll(" ", "")] = afilterData.Id;
        }
        let RiskAdjusted =
          this.RiskAdjustedReturn !== "" ? this.RiskAdjustedReturn : 3;
        let selectedBenchMark = this.selectedBenchMarkName
          ? this.selectedBenchMarkName
          : "";
        // payload object
        let data = {
          RiskAdjusted: RiskAdjusted,
          selectedBenchMark: selectedBenchMark,
          CorpId,
          ...applyFilterObj,
        };
        // console.log("data-------->>>", data);
        // data emit here and get in parent component.
        this.$emit("customIndexPayLoad", data);
      } else {
        this.showToast(
          "No companies found matching the criteria applied. Please update filter and try again.",
          "warning"
        );
      }
    },
    // show toast----
    showToast(message, type) {
      let showMessage = message
        .toLowerCase()
        .toString()
        .replace(/(^|\. *)([a-z])/g, function(match, separator, char) {
          return separator + char.toUpperCase();
        });
      this.$toast.open({
        message: showMessage,
        type: type,
        duration: 3000,
        dismissible: true,
        position: "top",
      });
    },
    // float number one digit show if have or not
    numberFormater(field, dataItem) {
      let data = dataItem[field];
      if (!isFinite(data)) {
        return data; // Return the original number
      }
      if (data < 100) {
        // Check if the number has a decimal part
        if (Math.floor(data) === data) {
          return data.toFixed(1); // Format with one decimal place
        } else {
          return data.toFixed(1); // Format with one decimal place
        }
      } else {
        return data;
      }
    },
  },
};
</script>
<style lang="scss"></style>
